import { render, staticRenderFns } from "./LayoutParametrizacao.vue?vue&type=template&id=5728798c"
import script from "./LayoutParametrizacao.vue?vue&type=script&lang=js"
export * from "./LayoutParametrizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports